export default __webpack_public_path__ + "static/media/arrow-down-circle-fill.f13422ca.svg";